<template>
  <transition name="header" appear mode="in-out">
    <!-- <header role="header" class="Header" :class="{ 'Header_sticky': isSticky }" :key="isSticky ? 'sticky' : 'base'"> -->
    <header role="header" class="Header"  v-if="response">
      <h1>So Beautiful By Sarah</h1>

      <div class="Header_wrapper">
        <router-link to="/" class="Header_logo"><img :src="response.brand.url" alt="So Beautiful By Sarah" /></router-link>
        <div class="Header_burger" @click="toggle" :key="isOpen ? 'close' : 'open'"><i class="icon-menu" v-if="!isOpen"></i><i class="icon-close" v-else></i></div>

        <transition name="nav" v-if="isMobile">
          <div class="Header_content" v-show="isOpen">
            <nav role="navigation" class="Header_nav">
              <router-link :class="{ active: isLinkActive(link.target) }" v-for=" (link,i) of response.nav" :to=" link.target === 'accueil' ? '/' : '/'+link.target " class="Header_nav_item">{{ link.label }}</router-link>
            </nav>
          </div>
        </transition>

        <div class="Header_content" v-else>
          <nav role="navigation" class="Header_nav">
              <router-link :class="{ active: isLinkActive(link.target) }"  v-for=" (link,i) of response.nav" :to=" link.target === 'accueil' ? '/' : '/'+link.target " class="Header_nav_item">{{ link.label }}</router-link>

          </nav>
        </div>
      </div>

    </header>
  </transition>
</template>

<script>
import PrismicFetch from "@/mixins/prismicFetch";
  export default {
    name: 'Header',
      mixins: [ PrismicFetch ],
    data() {
      return {
        isSticky: false,
        isOpen: false,
        isMobile: true,
      }
    },
    watch: {
      $route(to, from)
      {
        if(this.isOpen && to != from)
        {
          this.toggle()
        }
      }
    },
    methods: {
        isLinkActive(route) {
            if (this.$route.path.includes(route)) {
                return true
            }
        },
      toggle()
      {
        if(!this.isMobile) return

        this.isOpen = !this.isOpen

        if(this.isOpen)
        {
          this.$tools.disableScroll()
        }else{
          this.$tools.enableScroll()
        }
      },
      onResize()
      {
        if(window.innerWidth <= 768){
          this.isMobile = true
          this.onScroll()
        }
        else{
          this.isMobile = false
          if(this.isOpen)
            this.$tools.enableScroll()

          this.isOpen = false
        }
      },
      onScroll()
      {
        if(this.isMobile){
          this.isSticky = false
          return
        }

        // sticky
        // if (window.pageYOffset != 0) {
        //   this.isSticky = true
        // } else {
        //   this.isSticky = false
        // }
      }
    },
    beforeDestroy()
    {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onResize)
    },
    mounted()
    {
      setTimeout( () => {
        this.onScroll()
        window.addEventListener('scroll', this.onScroll)

        this.onResize()
        window.addEventListener('resize', this.onResize)
      }, 1000)
    },
      created() {
        this.getContent('header')
      }
  }
</script>

<style lang="stylus" scoped>

.Header
  position fixed
  top 0px
  left 0px
  right 0px
  width 100%
  z-index 1000
  background-color $darker-beige

  &_burger
    display none

    @media $small
      display block
      // height 50px
      // width 50px
      // display flex
      // flex-direction column
      // align-items center
      // text-align center
      // justify-content center
      cursor pointer

      i,svg
        color white
        font-size 26px

        @media $xsmall
          font-size 22px

      i.icon-close
        font-size 20px

        @media $xsmall
          font-size 16px


  // &_sticky

  //   .Header

  //     &_wrapper
  //       padding 25px 50px

  //     &_logo
        // width 100px

  &_wrapper
    padding 25px 50px
    box-sizing border-box
    margin 0px auto
    width 90%
    max-width $max-width
    display flex
    flex-direction row
    align-items center
    justify-content space-between
    text-transform uppercase
    letter-spacing 1px
    transition .3s all $ease

    @media $small
      padding 20px 40px

    @media $xsmall
      padding 15px 0
      // flex-direction row

  &_content

    @media $small
      position fixed
      bottom 0px
      left 0px
      right 0px
      max-width unset
      flex-direction column
      background-color $dark-brown
      height 100vh
      height calc(100vh - var(--vh, 0px));
      width 100vw
      z-index -1
      box-shadow 0px -20px 30px rgba(0,0,0,0.1)
      align-items center
      overflow-y auto
      box-sizing border-box

  &_logo
    width 120px
    position relative
    z-index 9

    img
      width 100%
      display block

    @media $medium
      width 100px

    @media $small
      width 90px

    @media $xsmall
      width 80px

  &_nav
    font-family $ftertiary
    margin-left 0px
    margin-right auto

    @media $small
      margin-bottom 0px
      margin-top auto
      display flex
      flex-direction column
      align-items center
      width 100%
      position relative
      top 50%
      transform translateY(-50%)

    a
      color white
      margin 0px 20px
      cursor pointer

        &:hover
          color $beige !important

        &:last-child
          margin-right 0

      @media $small
        display table
        margin-bottom 80px
        font-size 22px
        line-height 22px
        font-weight 900

        &:last-child
          margin-bottom 0

      &.router-link-exact-active
        color $dark-beige

  h1
    position fixed
    top -100%
    left 0px

.active
  color : #b48371 !important
</style>
